<template>
    <div>
        <el-page-header @back="goBack" content="被依赖查询" title="返回">
        </el-page-header>
        <el-row>
            <h3>实例信息</h3>
            <el-form inline >
                <el-form-item label="ID：">{{currentInstance.id}}</el-form-item>
                <el-form-item label="模块类型：" style="margin: 0 15px;">{{currentInstance.moduleType}}</el-form-item>
                <el-form-item label="模块版本：" style="margin:0 15px;">{{currentInstance.moduleVersion}}</el-form-item>
            </el-form>
        </el-row>
        <el-row>
            <h3>依赖该实例的实例</h3>
        </el-row>
        <el-row>
            <el-table :data="dependedList">
                <el-table-column align="center" prop="id" label="实例ID"></el-table-column>
                <el-table-column align="center" prop="moduleType" label="模块类型"></el-table-column>
                <el-table-column align="center" prop="moduleVersion" label="模块版本"></el-table-column>
                <el-table-column align="center" label="操作" width="200px;">
                    <template v-slot="{row}">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="dependUpdate(row)"
                        >依赖更新</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row style="text-align: center;margin-top: 40px;">
            <el-button type="primary" @click="goBack">关闭</el-button>
        </el-row>

        <depend
            v-if="showDepend"
            :visible="showDepend"
            :instanceId="item.id"
            :module="item.moduleType"
            :isEdit="true"
            :targetModule="currentInstance.moduleType"
            @dependCallback="showDepend = false"
        />
    </div>
</template>
<script>
import Depend from "./Dependency.vue";
export default {
    name: 'InstanceDepended',
    components: { Depend },
    data: vm=>({
        currentInstance: {}, //当前实例信息
        dependedList: [], //依赖该实例的实例列表
        showDepend: false,
        item: {}, //操作的实例
    }),
    created(){
        this.currentInstance = this.$route.params
        if(this.currentInstance.id){
            this.getAllInstanceDepende()
        }
    },
    methods: {
        goBack(){
            // this.$router.go(-1)
            this.$router.push({
                name: 'deployinstancelist',
                params: {
                    currentPage: this.currentInstance.currentPage
                }
            })
        },
        getAllInstanceDepende(){
            this.$axios
                .get(this.baseUrl3 + "instance/findByDependency/" + this.currentInstance.id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.dependedList = data ? data : []
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(err =>{
                    console.log(err);
                });
        },
        // 依赖更新
        dependUpdate(row){
            this.item = row
            this.showDepend = true
        },
    }
}
</script>
